var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicWandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.501 1.49805L20.001 2.89805L17.501 1.49805L18.901 3.99805L17.501 6.49805L20.001 5.09805L22.501 6.49805L21.101 3.99805L22.501 1.49805ZM14.871 6.78805C14.481 6.39805 13.851 6.39805 13.461 6.78805L1.79104 18.458C1.40104 18.848 1.40104 19.478 1.79104 19.868L4.13104 22.208C4.52104 22.598 5.15104 22.598 5.54104 22.208L17.201 10.548C17.591 10.158 17.591 9.52805 17.201 9.13805L14.871 6.78805ZM13.841 12.278L11.721 10.158L14.161 7.71805L16.281 9.83805L13.841 12.278Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWandIcon);
export default __webpack_public_path__ + "static/media/magic_wand_icon.5ce108a1.svg";
export { ForwardRef as ReactComponent };